import React from 'react';

import { stringTemplate } from 'shared/utils/stringTemplate';

import { useFooterContext } from '../FooterContext';

import styles from './styles.module.scss';

const FooterCopyright = () => {
  const {
    data: { copyright, isForLanderPage }
  } = useFooterContext();

  return (
    <div className={isForLanderPage ? styles.copyrightLander : styles.copyright}>
      {stringTemplate(copyright, { year: new Date().getFullYear() })}
    </div>
  );
};

export default FooterCopyright;
